import { FolderPrimaryListDto } from '@common/dto/folder/primary-list-dto';
import { HttpSuccessDto } from '@common/dto/http';
import client from '@common/utils/rest';

export type ModuleFoldersSetUp = { rootFolderName: string; rootFolderImgUrl: string; rootFolderId?: number | string; };

export type GetModuleFoldersParams = {
  folderTypeId: number;
  systemFolderConfig?: { include?: boolean };
  setUp: ModuleFoldersSetUp;
};

export const getModuleFolders = ({ 
  folderTypeId, 
  setUp,
  systemFolderConfig
}: GetModuleFoldersParams) => {
  return client({
    path: 'api/folders/module/loadFolders',
    params: {
      folderTypeId
    },
    method: 'GET',
  }).then((response: HttpSuccessDto<Array<FolderPrimaryListDto>>) => {
    const createRootFolder = ({ id, name, children, imageURL, system }: Partial<FolderPrimaryListDto>) => {
      return {
        id, 
        name,
        children,
        imageURL,
        system,
        imageURLSelected: imageURL,
      };
    };
    
    const foldersByType = response.entity.reduce<{ custom: Array<FolderPrimaryListDto>; system: Array<FolderPrimaryListDto> }>((acc, folder) => {
      if (folder.system) {
        folder.imageURL = 'gif/system.gif';
        folder.imageURLSelected = 'gif/system.gif';

        acc.system.push(folder);
      } else {
        acc.custom.push(folder);
      }

      return acc;
    }, { custom: [], system: [] });

    const systemRootFolder = createRootFolder({
      id: 0,
      name: 'System Fields',
      children: foldersByType.system,
      imageURL: 'gif/system.gif',
      system: true,
    });
    const customRootFolder = createRootFolder({
      id: setUp.rootFolderId ?? '' as any,
      name: setUp.rootFolderName,
      children: foldersByType.custom,
      imageURL: setUp.rootFolderImgUrl,
      system: false,
    });

    const folders = [customRootFolder];

    const includeSystemRootFolder = systemFolderConfig?.include ?? true;

    if (includeSystemRootFolder) {
      folders.unshift(systemRootFolder);
    }

    return folders;
  });
};